/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Validation_Name_LengthInputs */

const fr_validation_name_length = /** @type {(inputs: Validation_Name_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saisissez un nom (200 caractères maximum).`)
};

const en_validation_name_length = /** @type {(inputs: Validation_Name_LengthInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter a name (up to 200 characters).`)
};

/**
* | output |
* | --- |
* | "Enter a name (up to 200 characters)." |
*
* @param {Validation_Name_LengthInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const validation_name_length = /** @type {((inputs?: Validation_Name_LengthInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Validation_Name_LengthInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_validation_name_length(inputs)
	return fr_validation_name_length(inputs)
});